import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  inset: 0;
  z-index: 9999;

  background-color: rgb(211 228 255 /70%);
  backdrop-filter: blur(4px);

  animation: entering 0.5s forwards;

  &.modal-product-list--hide{
    animation: exiting 0.5s forwards;
  }
`;

export const ModalContainer = styled.div`
  width: 95%;
  max-width: 33.25rem;
  padding: 3rem;
  padding-right: 1.5rem;

  max-height: 100vh;

  font-family: 'Axiforma', sans-serif;

  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 17px;
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16);

  gap: 2rem;

  .modal-product-list__title {
    font-size: 1.75rem;
    line-height: 1.15;
    font-weight: bold;
    color: var(--blue00);
  }

  .modal-product-list__list-wrapper {
    max-height: 40rem;

    overflow: auto;

    width: 100%;

    padding-right: 2rem;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #D5EAFC;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--blue00);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      opacity: 0.9;
    }
  }

  .modal-product-list__list-items-container {
    display: flex;
    flex-direction: column;

    gap: 1rem;

    padding: 0.5rem;
  }

  .modal-product-list__list-item {
    border-radius: 1rem;
    padding: 1.25rem;

    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

    color: rgba(44, 44, 44, 0.69);

    line-height: 1.15;

    h2 {
      font-size: 1.125rem;
      margin-bottom: 0.875rem;
    }

    p {
      font-size: 1rem;
    }
  }

  .modal-product-list__load-more {
    height: 20px;
    width: 100%;
  }
`;
